import { Component, Input } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { ProductCreateFoodcostSelectIngPage } from "../../product-create/product-create-foodcost/product-create-foodcost-select-ing/product-create-foodcost-select-ing";
import { ProductCreateWfoodcostSelectProviderPage } from "../../product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-create-wfoodcost-select-provider";
import { Globals } from "../../../../globals";

/**
 * Generated class for the ProductViewListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-view-list',
  templateUrl: 'product-view-list.html',
})
export class ProductViewListPage {
  @Input() product: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals) {
  }

  editCIngredients() {
    this.navCtrl.push(ProductCreateFoodcostSelectIngPage, {
      update_state: true,
      product_uid: this.product.UID,
      products: this.product,
      product_name: this.product.name,
      pvp: this.product.pvp,
      product: this.product
    });

  }

  editProviders() {
    this.navCtrl.push(ProductCreateWfoodcostSelectProviderPage, {
      update_state: true,
      product_uid: this.product.UID,
      products: this.product,
      product_name: this.product.name,
      product_measurement: this.product.measurement,
      product: this.product
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view-list/product-view-list.ts